import React, { Component } from 'react';
import { Link } from 'react-scroll';
import Mailto from 'react-mailto.js';
import Fade from 'react-reveal/Fade';

// images
import logo from './images/Whofolio_Logo.png';


class Header extends Component {
  render() {
    return (
      <header className="whofolio-header container-fluid">

        <div className="top-bar">
          <div className="logo">
            <img src={logo} alt="whofolio logo" />
          </div>

          <nav className="main-menu">
            <ul>
              <li>
                <Link to="video" spy={true} smooth={true}>How it works</Link>
              </li>
              <li>
                <Link to="grow" spy={true} smooth={true}>Investors</Link>
              </li>
              <li className="last">
                <Mailto
                  secure={true}
                  to='info@whofolio.com'
                  subject="Contact from the website">
                  Contact
                </Mailto>
              </li>
            </ul>
          </nav>

          <div className="login">

          </div>
        </div>

        <Fade>
        <div className="hero-text">
          <h1>Connect. Collaborate. Create.</h1>
          <h2>A NEW and SECURE way to connect people to get work done.</h2>
        </div>
        </Fade>

      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/assets/components/header.js